import { mapGetters } from "vuex";
import { planTypes } from '@/common/constants';
import { computedCallingPlans } from '@/common/service/computers/plans/pbx';
import { scrollToTop } from "@/views/checkout/utils";

export default {
  data() {
    return {
      mx_alertOpts: null
    }
  },
  created() {
    this.$context.$on('desk-phone-alert', (opts) => {
      this.$tracking.buyInteraction('banner - product level', `desk phone - ${opts.title}. ${opts.description} - impression`);
      this.mx_alertOpts = opts
      if (opts) {
        !this.isExpanded && (this.isExpanded = true);
        this.$nextTick(() => {
          if (this.$refs.mx_alert) {
            scrollToTop(this.$refs.mx_alert.$el);
          }
        })
      }
    });
  },
  computed: {
    ...mapGetters(['getSelectedPlans']),
    deskPhoneSum() {
      const selectedDeskPhones = this.getSelectedPlans.filter(item => item.type === planTypes.DESK_PHONES);
      const deskPhoneSum = selectedDeskPhones.reduce((pre, curVal) => (curVal?.cartInfo?.selected_number || 0) + pre, 0)
      return deskPhoneSum
    },
    callingSum() {
      const selectedCallingPlans = computedCallingPlans(this.getSelectedPlans);
      const callingSum = selectedCallingPlans.reduce((pre, curVal) => (curVal?.cartInfo?.selected_number || 0) + pre, 0)
      return callingSum
    },
    isSame() {
      return this.deskPhoneSum === this.callingSum
    }
  },
  beforeDestroy() {
    this.$context.$off('desk-phone-alert');
  },
  watch: {
    isSame(val, oldVal) {
      if (!oldVal && val) {
        this.$context.$emit('desk-phone-alert', null);
      }
    }
  }
}
